import { ConversationListItem } from "../interface/shiftConversation";

export function zeroUnreadForConversation(
  items: ConversationListItem[],
  conversationId: string,
): ConversationListItem[] {
  const id = String(conversationId || "").trim();
  if (!id) return items;

  return items.map((item) =>
    item.conversation?.conversationId === id
      ? {
          ...item,
          conversation: {
            ...item.conversation,
            unreadCount: 0,
          },
        }
      : item,
  );
}

export type ShiftConversationUpdatedDetail = {
  conversationId?: string;
  clearedUnread?: boolean;
};

export function readShiftConversationUpdatedDetail(
  event: Event,
): ShiftConversationUpdatedDetail | null {
  const detail = (event as CustomEvent<ShiftConversationUpdatedDetail>).detail;
  if (!detail || typeof detail !== "object") return null;
  return detail;
}
